// Content sourced verbatim from the client's supplied Melbourne guide copy.
import { galleryFrom, leadFrom, countFrom } from "./fromModels";

const slug = "the-harem-palace";

const harem = {
  slug,
  name: "The Harem Palace",
  short: "Harem",
  badge: "South Melbourne",
  suburb: "South Melbourne",
  established: "Park Street, Harem name since the 1990s",
  tagline:
    "A larger, longstanding Park Street name known for its interiors, private rooms and more elaborate environment.",
  lead: leadFrom(slug),
  theme: {
    bg: "bg-[#f4f1fd]",
    chip: "bg-[#e2dcfb] text-[#4a2f9c]",
    rule: "border-[#bda9f5]",
    accent: "text-[#5a37b8]",
  },
  gallery: galleryFrom(slug),
  highlights: [
    { icon: "Users", label: `${countFrom(slug)} Ladies` },
    { icon: "MapPin", label: "South Melbourne" },
    { icon: "Clock", label: "Confirm current hours" },
  ],
  contact: {
    address: "55 Park Street, South Melbourne",
  },
  nav: [
    { id: "introduction", label: "Introduction" },
    { id: "models", label: "Models" },
  ],
  sections: [
    {
      id: "introduction",
      eyebrow: "The Harem Palace, South Melbourne",
      title: "The Harem Palace, South Melbourne",
      blocks: [
        { t: "lead", text: "Address: 55 Park Street, South Melbourne" },
        {
          t: "p",
          text: "Park Street is a familiar address to people who know Melbourne's adult entertainment scene.",
        },
        {
          t: "p",
          text: "It's close to the CBD and Southbank, yet the surrounding streets feel quite different from the crowded restaurant and bar precincts a short distance away.",
        },
        {
          t: "p",
          text: "The Harem Palace is one of the better known names associated with this part of Melbourne.",
        },
        {
          t: "p",
          text: "The Harem name has been around for years, although its history includes changes along the way. An earlier operation closed in 2018, and later references to The Harem Palace reflect the business's subsequent development.",
        },
        {
          t: "p",
          text: "That background is worth knowing when looking through older reviews. A comment written many years ago might describe a previous version of the establishment rather than what exists today.",
        },
        {
          t: "p",
          text: "What makes Harem different from a smaller suburban studio is the scale and presentation traditionally associated with the premises.",
        },
        {
          t: "p",
          text: "Its reputation has been built partly around its interiors, private rooms and a more elaborate environment.",
        },
        {
          t: "p",
          text: "For some visitors, the surroundings are part of the attraction. They want somewhere that feels like a destination rather than simply a place to make a booking.",
        },
        {
          t: "p",
          text: "Others care much less about the decor. They're more interested in the person they're meeting, the price and whether the experience lives up to what was discussed.",
        },
        { t: "p", text: "Neither preference is unusual." },
        {
          t: "p",
          text: "Independent discussions of Harem have covered everything from its rooms and reception experience to individual customer expectations. As you might expect with a business that's attracted attention over many years, the feedback isn't all the same.",
        },
        {
          t: "p",
          text: "One customer might appreciate the setting, while another might question whether the price represents good value.",
        },
        {
          t: "p",
          text: "It's worth reading those comments with a little perspective, especially when they relate to particular workers or circumstances that may have changed.",
        },
        { t: "p", text: "The location is one of Harem's obvious advantages." },
        {
          t: "p",
          text: "Someone staying in Southbank or central Melbourne can reach Park Street without making a long trip into the suburbs. It's also accessible from the southern side of the city.",
        },
        {
          t: "p",
          text: "If you're comparing Melbourne brothels and prefer a larger establishment with a longstanding name, Harem is one to research.",
        },
        {
          t: "note",
          text: "Current contact and booking information can be found at The Harem Palace.",
        },
      ],
    },
  ],
};

export default harem;
